<template>
  <div class="container container-table">
    SETTINGS
  </div>
</template>
<script>
  export default {
    name: 'Settings'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/Settings.vue